<template>
	<div class="view-reset-password">
		<password-reset-form
			class="view-reset-password__form"
			v-bind="{ token, errors }"
			:loading="isLoading"
			@submit="resetPassword"
		/>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import PasswordResetForm from '@/components/password/reset/PasswordResetForm.vue';
import { authActions } from '@/store/modules/auth';
import { ResetPasswordPayload } from '@/store/modules/auth/types';
import { InstanceApiErrors, mapErrorMessagesToInstance, onApiError } from '@/tools/helpers';

export default defineComponent({
	components: {
		PasswordResetForm,
	},

	data() {
		return {
			errors: {} as InstanceApiErrors,
		};
	},

	computed: {
		isLoading(): boolean {
			return this.$isLoading(['auth/resetPassword']);
		},

		token(): string {
			const { token } = this.$route.params;

			return Array.isArray(token) ? token[0] : token;
		},
	},

	methods: {
		async resetPassword(data: ResetPasswordPayload) {
			try {
				await authActions.resetPassword(data);
				this.$toast.open({
					message: 'Your new password has been set. You can now use it to sign in.',
					timeout: 6000,
				});
				this.$router.push({ name: 'login' });
			} catch (e) {
				onApiError(e, {
					422: error => {
						const { errors = {} } = error.response?.data ?? {};

						mapErrorMessagesToInstance(errors, this.errors);
					},
					default: () => {
						this.$toast.open({
							message:
								"We're sorry, but something is not right. Provided e-mail address is incorrect or the link has already expired.",
						});
					},
				});
			}
		},
	},
});
</script>
